import React from "react";

export default function BarIcon() {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1.80001C6 1.13729 6.53728 0.600006 7.2 0.600006H22.8C23.4627 0.600006 24 1.13729 24 1.80001C24 2.46272 23.4627 3.00001 22.8 3.00001H7.2C6.53728 3.00001 6 2.46268 6 1.80001ZM22.8 7.80001H1.2C0.537281 7.80001 0 8.33733 0 9.00001C0 9.66272 0.537281 10.2 1.2 10.2H22.8C23.4627 10.2 24 9.66272 24 9.00001C24 8.33733 23.4627 7.80001 22.8 7.80001ZM22.8 15H12C11.3373 15 10.8 15.5373 10.8 16.2C10.8 16.8627 11.3373 17.4 12 17.4H22.8C23.4627 17.4 24 16.8627 24 16.2C24 15.5373 23.4627 15 22.8 15Z"
        fill="#F26739"
      />
    </svg>
  );
}
